// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Switch_backdrop__3pmhb","label":"Switch_label__13CCE","fields":"Switch_fields__2lytB"};